// The one address of a client's chat in the admin: the Conversations tab,
// opened on that chat (AdminAssistantPage reads `tab` and `chat`).
//
// Owner, 2026-09-28: « add here a button redirect to this exact conversation »
// — on the order page, which shows the thread read-only.
//
// Guard: conversationLink.test.ts
export function conversationHref(chatId: string | null | undefined): string | null {
  const id = String(chatId ?? '').trim();
  if (!id) return null;
  return `/admin/assistant?tab=conversations&chat=${encodeURIComponent(id)}`;
}
